export const getBasename: () => string = () => {
  if (window.location.pathname === '/Fundraiser/Start') {
    window.location.replace('https://v2.fan-pledge.com/Fundraiser/Start');
  }
  const basename = window.location.pathname.replace(/^\/([^/]+).*/, '/$1');
  return basename === '/Fundraiser' ? '/' : basename;
};
